import Vue from 'vue'
import App from './App.vue'
import router from './uteis/router'
import store from './uteis/store'
import VTooltip from 'v-tooltip'

import '../src/assets/scss/app.scss'
import '../src/assets/scss/vuelidate.scss'
import '../src/assets/scss/tooltip.scss'
import 'font-awesome/css/font-awesome.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import VueTheMask from 'vue-the-mask'
import Vuelidate from 'vuelidate'

Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.use(VTooltip)

Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
